import React from "react";
import { Route, Switch } from "react-router-dom";

import Add from "./Add";
import List from "./List";
import Summary from "./Summary";
import Edit from "./Edit";
import Confirm from "./Confirm";
import Upload from "./Upload";

import SiluetaAdd from "./silueta/Add";

import PrymAdd from "./prym/Add";
import PrymAddWithLines from "./prym/AddWithLines";
import PrymEditWithLines from "./prym/EditWithLines";
import PrymList from "./prym/List";
import PrymSummary from "./prym/Summary";
import PrymEdit from "./prym/Edit";
import PrymConfirm from "./prym/Confirm";

import StrRmAddWithLines from "./str_rm/AddWithLines";
import StrRmSummary from "./str_rm/Summary";
import StrRmConfirm from "./str_rm/Confirm";
import StrRmEditWithLines from "./str_rm/EditWithLines";
import StrRmList from "./str_rm/List";

import StrGrAdd from "./str_gr/Add";
import StrGrSummary from "./str_gr/Summary";
import StrGrEdit from "./str_gr/Edit";
import StrGrConfirm from "./str_gr/Confirm";

import SiluetaSummary from "./silueta/Summary";
import SiluetaEdit from "./silueta/Edit";
import SiluetaConfirm from "./silueta/Confirm";

import OtrAddWithLines from "./otr/AddWithLines";
import OtrEditWithLines from "./otr/EditWithLines";
import OtrList from "./otr/List";
import OtrSummary from "./otr/Summary";
import OtrEdit from "./otr/Edit";
import OtrConfirm from "./otr/Confirm";

import TiepAddWithLines from "./tiep/AddWithLines";
import TiepEditWithLines from "./tiep/EditWithLines";
import TiepList from "./tiep/List";
import TiepSummary from "./tiep/Summary";
import TiepEdit from "./tiep/Edit";
import TiepConfirm from "./tiep/Confirm";
import TiepIssueToJob from "./tiep/IssueToJob";
import TiepAsycuda from "./tiep/Asycuda";
import UploadAsyCuda from "./tiep/UploadAsyCuda";
import TiepDocuments from "./tiep/Documents";
import TiepHistory from "./tiep/History";
import TiepReciptTransactions from "./tiep/Transactions";
import TiepIssueWriteOff from "./tiep/IssueWriteOff";
import AquaAddWithLines from "./aqua/AddWithLines";
import AquaEditWithLines from "./aqua/EditWithLines";
import AquaList from "./aqua/List";
import AquaSummary from "./aqua/Summary";
import AquaConfirm from "./aqua/Confirm";
import AquaHistory from "./aqua/History";
import AquaDocument from "./aqua/Document";

import { Auth } from "_helpers";

function StockIssue({ match }) {
  const { path } = match;
  const loggedInCustomerCode = Auth.getProfile().comp_code;
  if (loggedInCustomerCode === "SILUETA") {
    return (
      <Switch>
        <Route exact path={path} component={List} />
        <Route path={`${path}/add`} component={SiluetaAdd} />
        <Route path={`${path}/:id/summary`} component={SiluetaSummary} />
        <Route path={`${path}/:id/edit`} component={SiluetaEdit} />
        <Route path={`${path}/:id/confirm`} component={SiluetaConfirm} />
        <Route path={`${path}/upload`} component={Upload} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "STR_GR") {
    return (
      <Switch>
        <Route exact path={path} component={List} />
        <Route path={`${path}/add`} component={StrGrAdd} />
        <Route path={`${path}/:id/summary`} component={StrGrSummary} />
        <Route path={`${path}/:id/edit`} component={StrGrEdit} />
        <Route path={`${path}/:id/confirm`} component={StrGrConfirm} />
        <Route path={`${path}/upload`} component={Upload} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "STR") {
    return (
      <Switch>
        <Route exact path={path} component={StrRmList} />
        <Route path={`${path}/add`} component={StrRmAddWithLines} />
        <Route path={`${path}/:id/summary`} component={StrRmSummary} />
        <Route path={`${path}/:id/edit`} component={StrRmEditWithLines} />
        <Route path={`${path}/:id/confirm`} component={StrRmConfirm} />
        <Route path={`${path}/upload`} component={Upload} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "PRYM") {
    return (
      <Switch>
        <Route exact path={path} component={PrymList} />
        <Route path={`${path}/add`} component={PrymAddWithLines} />
        <Route path={`${path}/:id/summary`} component={PrymSummary} />
        <Route path={`${path}/:id/edit`} component={PrymEditWithLines} />
        <Route path={`${path}/:id/confirm`} component={PrymConfirm} />
        <Route path={`${path}/upload`} component={Upload} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "OTR") {
    return (
      <Switch>
        <Route exact path={path} component={OtrList} />
        <Route path={`${path}/add`} component={OtrAddWithLines} />
        <Route path={`${path}/:id/summary`} component={OtrSummary} />
        <Route path={`${path}/:id/edit`} component={OtrEditWithLines} />
        <Route path={`${path}/:id/confirm`} component={OtrConfirm} />
        <Route path={`${path}/upload`} component={Upload} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "TIEP") {
    return (
      <Switch>
        <Route exact path={path} component={TiepList} />
        <Route path={`${path}/add`} component={TiepAddWithLines} />
        <Route path={`${path}/issue-to-job`} component={TiepIssueToJob} />
        <Route path={`${path}/:id/asycuda`} component={TiepAsycuda} />
        <Route path={`${path}/:id/summary`} component={TiepSummary} />
        <Route path={`${path}/:id/edit`} component={TiepEditWithLines} />
        <Route path={`${path}/:id/confirm`} component={TiepConfirm} />
        <Route path={`${path}/:id/history`} component={TiepHistory} />
        <Route path={`${path}/:id/documents`} component={TiepDocuments} />
        <Route
          path={`${path}/:id/transactions`}
          component={TiepReciptTransactions}
        />
        <Route path={`${path}/upload`} component={Upload} />
        <Route path={`${path}/:id/write-off`} component={TiepIssueWriteOff} />
        <Route path={`${path}/upload-asycuda`} component={UploadAsyCuda} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "AQUA") {
    return (
      <Switch>
        <Route exact path={path} component={AquaList} />
        <Route path={`${path}/add`} component={AquaAddWithLines} />
        <Route path={`${path}/:id/summary`} component={AquaSummary} />
        <Route path={`${path}/:id/edit`} component={AquaEditWithLines} />
        <Route path={`${path}/:id/confirm`} component={AquaConfirm} />
        <Route path={`${path}/:id/history`} component={AquaHistory} />
        <Route path={`${path}/:id/documents`} component={AquaDocument} />
      </Switch>
    );
  } else {
    return (
      <Switch>
        <Route exact path={path} component={List} />
        <Route path={`${path}/add`} component={Add} />
        <Route path={`${path}/:id/summary`} component={Summary} />
        <Route path={`${path}/:id/edit`} component={Edit} />
        <Route path={`${path}/:id/confirm`} component={Confirm} />
        <Route path={`${path}/upload`} component={Upload} />
      </Switch>
    );
  }
}

export { StockIssue };
